module.exports = __webpack_public_path__ + "img/img-1-mobile.a8e92ffa.png";